const fetchBundleProducts = async ({
  variant,
  storeKey,
  locale,
}: {
  variant: any;
  storeKey: string;
  locale: string;
}) => {
  const res = await fetch(`/${locale}/api/bundle-products/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ variant, storeKey }),
  });

  if (!res.ok) {
    throw new Error(`Failed to fetch bundle products: ${res.statusText}`);
  }

  return await res.json();
};

export { fetchBundleProducts };
